import axios from "axios";
import store from "../store";
import { statuses } from "../constants";
import { getItem } from "../utils/tokenTools";

let customerId = 0;
let customerNo = 0;

function getIsEsube() {
  if (typeof window === "undefined") return null;
  return getItem("esube");
}

function conditionalHeader(token, extraHeaders, cId) {
  const isEsube = getIsEsube();

  if (isEsube === "yes" || isEsube == null) {
    return {
      Authorization: token ? `Bearer ${token}` : null,
      ...extraHeaders,
    };
  } else if (isEsube === "no") {
    return {
      Authorization: token ? `Bearer ${token}` : null,
      CustomerId: cId ? cId : customerId,
      CustomerNo: customerNo,
      ...extraHeaders,
    };
  } else {
    return {
      Authorization: token ? `Bearer ${token}` : null,
      ...extraHeaders,
    };
  }
}
const setCustomerInfo = () => {
  if (process.env.VUE_APP_MODE !== "library") {
    customerId = getItem("userId");
    customerNo = getItem("cusNo");
  } else {
    customerId = parseInt(localStorage.getItem("userId"));
    customerNo = parseInt(localStorage.getItem("cusNo"));
  }
};

function createAxiosInstance() {
  let instance = axios.create({
    baseURL:
      process.env.VUE_APP_MODE !== "library"
        ? process.env.VUE_APP_API_URL
        : localStorage.getItem("ovdApiUrl"),
    headers: {
      "Strict-Transport-Security": "max-age=31536000",
      "X-Content-Type-Options": "nosniff",
      "X-Xss-Protection": "1; mode=block",
      "X-Frame-Options": "SAMEORIGIN",
      "Content-Security-Policy": "default-src 'self';",
      "Cache-Control": "no-cache, no-store, must-revalidate",
      Pragma: "no-cache",
      Expires: "0",
    },
  });
  setCustomerInfo();
  instance.interceptors.response.use(
    (response) => {
      if (response.data.error) {
        // OPTIMUS STATE CHECK
        if (response.data.message.includes("Unauthorized")) {
          store.dispatch("logout");
        }
      }
      return response;
    },
    (error) => {
      const status = error?.response?.status;
      // global handling component pass props this error.
      if (!status || status === statuses.UNAUTHORIZED) {
        store.dispatch("logout");
      }
      return Promise.reject(error);
    }
  );
  return instance;
}

const setAuthToken = (token) => {
  let instance = createAxiosInstance();
  if (token) {
    // applying token
    instance.defaults.headers.common.Authorization = token;
  } else {
    // deleting the token from header
    delete instance.defaults.headers.common.Authorization;
  }
};
// override instance get method
const get = (endpoint, extraHeaders = {}, cId = null) => {
  const token = getItem("veri-dagitim-token");
  let instance = createAxiosInstance();
  return instance.get(endpoint, {
    headers: conditionalHeader(token, extraHeaders, cId),
  });
};

const post = (endpoint, data, extraHeaders = {}, cId = null) => {
  const token = getItem("veri-dagitim-token");
  let instance = createAxiosInstance();
  return instance.post(endpoint, data, {
    headers: conditionalHeader(token, extraHeaders, cId),
  });
};

// eslint-disable-next-line no-underscore-dangle
const _delete = (endpoint, data = {}, extraHeaders = {}) => {
  const token = getItem("veri-dagitim-token");
  let instance = createAxiosInstance();
  return instance.delete(
    endpoint,
    {
      headers: conditionalHeader(token, extraHeaders, null),
    },
    data
  );
};

// override put method
const put = (endpoint, data, extraHeaders = {}) => {
  const token = getItem("veri-dagitim-token");
  let instance = createAxiosInstance();
  return instance.put(endpoint, data, {
    headers: conditionalHeader(token, extraHeaders, null),
  });
};

export { setAuthToken, get, post, _delete, put };
